export default function CustomButtonConfirm({
    loading,
    textLoad = 'Procesando',
    text,
    handleOnClick,
    className = '',
    ...props
}) {
    return (
        <button
            type="submit"
            disabled={loading}
            onClick={handleOnClick}
            className={`
w-full
min-h-touch
flex items-center justify-center
rounded-xl
bg-cs-primary
text-white
text-base
font-medium
transition
disabled:opacity-60
disabled:cursor-not-allowed
${className}
`}
            {...props}
        >
            {loading ? (
                <>
                    <svg
                        className="animate-spin h-5 w-5 mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                    </svg>
                    <span>{textLoad}…</span>
                </>
            ) : (
                <span>{text}</span>
            )}
        </button>
    )
}